import LoginForm from "../UI/LoginForm/LoginForm";

const LoginView = () => {
  return <LoginForm />;
};

export default LoginView;
